"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
/**
 * Asserts that the specified expression is true and throws an error if not.
 *
 * @param expr the expression.
 * @param message the message for the Error.
 */
function assert(expr, message) {
    if (!expr) {
        throw new Error(message);
    }
}
exports.assert = assert;
